/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { WorkspaceObject, LockedWorkspaceId, lockedWorkspaces } from 'jotai/workspace';
import { WorkspaceServiceInterface } from './WorkspaceServiceInterface';
import { RunType, SanctioningBodyEnum, WorkspaceInfo } from 'models/viewModels';

class LockedWorkspaceService implements WorkspaceServiceInterface {
  getWorkspace(id: LockedWorkspaceId): WorkspaceObject {
    return structuredClone(lockedWorkspaces[id]);
  }

  getWorkspaceIds(): string[] {
    return Object.keys(lockedWorkspaces);
  }

  getAvailableWorkspaces(sessionType: RunType): WorkspaceObject[] {
    return structuredClone(
      Object.values(lockedWorkspaces).filter(
        (workspace) => !workspace.sessionTypes || workspace.sessionTypes.includes(sessionType)
      )
    );
  }

  getAllAvailableWorkspaces(): WorkspaceObject[] {
    return structuredClone(Object.values(lockedWorkspaces));
  }

  updateWorkspace() {
    return false;
  }

  getAvailableSanctioningBodyWorkspaces(sanctioningBody: SanctioningBodyEnum): WorkspaceObject[] {
    return structuredClone(
      Object.values(lockedWorkspaces).filter(
        (workspace) => !workspace.sanctioningBody || workspace.sanctioningBody === sanctioningBody
      )
    );
  }

  getAvailableSanctioningBodyWorkspacesInfo(sanctioningBody: SanctioningBodyEnum): WorkspaceInfo[] {
    const workspaces = structuredClone(
      Object.values(lockedWorkspaces).filter(
        (workspace) => !workspace.sanctioningBody || workspace.sanctioningBody === sanctioningBody
      )
    );
    return workspaces.map((workspace: WorkspaceObject) => {
      return {
        id: workspace.id,
        name: workspace.name,
        slug: workspace.slug,
        owner: workspace.owner,
        shared: workspace.shared || false,
        sharedDomains: workspace.sharedDomains || [],
        sanctioningBody: workspace.sanctioningBody || SanctioningBodyEnum.UNKNOWN,
      } as WorkspaceInfo;
    });
  }
}

export const lockedWorkspaceService = new LockedWorkspaceService();
